// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"2e4b7086","205":"c1726488","312":"522be1d1","374":"e611ec2c","484":"e9e1d10d","508":"3a6888a7","551":"b0771839","629":"9eb1b2e3","842":"33337c6a","869":"6863a5bd","974":"d60f2296"}[chunkId] + ".chunk.js";
};